import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * Búsqueda de texto con forma de píldora (lupa + ✕ para limpiar).
 * Es la búsqueda estándar de todas las pantallas; va dentro de `.filter-card`.
 *
 * - `(valueChange)` emite el texto.
 * - `(search)` emite un Event compatible con los `applyFilter(event)` que ya
 *   existían (leen `event.target.value`).
 */
@Component({
  selector: 'app-search-pill',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatTooltipModule],
  host: { class: 'search-pill-host' },
  template: `<mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-pill">
  <mat-icon matPrefix>search</mat-icon>
  <mat-label>{{ label }}</mat-label>
  <input matInput #inp [value]="value" [placeholder]="placeholder" [disabled]="disabled" autocomplete="off" (input)="onInput(inp, $event)" (keyup.enter)="enter.emit(inp.value)">
  @if (value) {<button mat-icon-button matSuffix type="button" matTooltip="Limpiar búsqueda" (click)="clear(inp)"><mat-icon>close</mat-icon></button>}
</mat-form-field>`,
})
export class SearchPillComponent {
  @Input() label = 'Buscar';
  @Input() placeholder = '';
  @Input() value: string | null = '';
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<Event>();
  @Output() enter = new EventEmitter<string>();

  onInput(inp: HTMLInputElement, ev: Event) {
    this.value = inp.value;
    this.valueChange.emit(inp.value);
    this.search.emit(ev);
  }

  clear(inp: HTMLInputElement) {
    inp.value = '';
    this.value = '';
    this.valueChange.emit('');
    this.search.emit({ target: inp } as unknown as Event);
    inp.focus();
  }
}
